'use client'

import Avatar from '@component/avatar'
import classNames from 'classnames'
import Sticky from 'react-stickynode'
import { useBoolean } from 'react-use'
import AgentPhoneButton from '@component/card/agent/button/phone'
import AgentEmailButton from '@component/card/agent/button/email'
import { getColliersClassName } from '@utils'

export default function AgentFixedInfo({
  data
}) {

  const [display, toggleDisplay] = useBoolean(false)
  function stateChangeHandle({ status }) {
    toggleDisplay(status === Sticky.STATUS_FIXED)
  }

  return (
    <Sticky onStateChange={stateChangeHandle} innerZ={200}>
      <div className={classNames('absolute inset-x-0 bg-white shadow-sm', { 'hidden': !display })}>
        <div className='section-wrap hidden md:block'>
          <div className='flex items-center justify-between py-18'>
            <div className='flex items-center'>
              <Avatar src={data.icon} className={classNames('flex-shrink-0', getColliersClassName(data.office))} alt={data.name} width={64} height={64} circle defaultIcon='icon-avatar'></Avatar>
              <div className='ml-16'>
                <div className='text-font text-lg font-normal'>{data.name}</div>
                {data.jobTitle && <div className='mt-4 text-neutral-5 text-base line-clamp-1'>{data.jobTitle}</div>}
              </div>
            </div>
            <div className='space-x-10 flex-shrink-0 ml-20'>
              <AgentEmailButton data={data} full={false} className='w-204'></AgentEmailButton>
              <AgentPhoneButton agent={data} data={data.phoneNumber} full={false} className='w-204'></AgentPhoneButton>
            </div>
          </div>
        </div>
        <div className='p-16 flex space-x-10 md:hidden'>
          <AgentPhoneButton agent={data} data={data.phoneNumber}>Call</AgentPhoneButton>
          <AgentEmailButton data={data}>Email</AgentEmailButton>
        </div>
      </div>
    </Sticky>
  )
}